<template>
  <div v-show="isVisible" :class="componentClassName">
    <div class="m-calling-pending-agents__label">取次保留</div>
    <div class="m-calling-pending-agents__buttons">
      <template v-for="(item, index) in currentList" :key="index">
        <a-button
          variant="icon"
          :icon="getButtonIcon(index)"
          :disabled="item.status === 'disabled' || shouldDisabled"
          :icon-color="getButtonIconColor(item)"
          :color="getButtonColor(item)"
          :class="getButtonClassName(item)"
          @click="handleHoldButtonClick(index)"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';

import { customRequest } from '@/common/customRequest.js';

export default {
  name: 'm-calling-pending-agents',
  components: {
    AButton,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: true,
    },
    activeId: {
      type: String,
      default: null,
    },
    availableList: {
      type: Array,
      default: new Array(0),
    },
    modelValue: {
      type: String,
      default: null,
    },
    minimized: {
      type: Boolean,
      default: false,
    },
    currentMemo: {
      type: String,
      default: '',
    },
    isConfirmationOk: {
      type: Boolean,
      default: false,
    },
    shouldDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onhold:activated', 'onhold:deactivated', 'update:modelValue', 'modal:show'],
  data() {
    return {
      currentActiveId: null,
      maximumAvailablePending: 3,
      confirmingItemID: null,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-calling-pending-agents', this.minimized ? 'minimized' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    currentList() {
      const list = [];
      for (let i = 0; i < this.maximumAvailablePending; i += 1) {
        const item = {
          id: '',
          status: 'disabled',
        };
        // check available list
        if (this.availableList) {
          const availableItem = this.availableList[i] || null;
          if (availableItem) {
            item.id = availableItem.id;
            if (this.currentActiveId === availableItem.id) {
              item.status = 'active';
            } else {
              item.status = availableItem.status ? 'disabled' : 'normal';
            }
          }
          list.push(item);
        }
      }
      return list;
    },
  },
  watch: {
    activeId(val) {
      this.currentActiveId = val;
    },
    modelValue(val) {
      this.currentActiveId = val;
    },
    isConfirmationOk(val) {
      if (val) this.handleAcceptModal();
    },
  },
  mounted() {
    if (this.activeId) {
      this.currentActiveId = this.activeId;
    }
  },
  methods: {
    getButtonIcon(index) {
      return `phone-call-${index + 1}`;
    },
    getButtonIconColor(item) {
      if (item.status === 'active') {
        return 'white';
      } else if (item.status === 'disabled' || this.shouldDisabled) {
        return 'grey';
      }
      return 'orange';
    },
    getButtonColor(item) {
      if (item.status === 'active') {
        return 'primary';
      } else if (item.status === 'disabled' || this.shouldDisabled) {
        return 'grey';
      }
      return 'white';
    },
    getButtonClassName(item) {
      const buttonClassName = mapModifiers(
        'm-calling-pending-agents__button',
        this.shouldDisabled ? 'disabled' : item.status
      );
      return buttonClassName;
    },
    handleHoldButtonClick(index) {
      const item = this.currentList[index] || null;
      if (item) {
        // check if this is the current on-hold or not
        if (this.currentActiveId !== item.id) {
          this.postRequest('/hold/hold-count-check').then(data => {
            if (data.status !== 'success') {
              this.$emit('modal:show', 'error', '保留中にエラーが発生しました。時間を空けて再度実行してください。');
              return;
            }
            if (data.isReached) {
              this.confirmingItemID = item.id;
              this.$emit('modal:show', 'info', 'これ以上の保留はできなくなりますが、よろしいですか？');
            } else {
              this.currentActiveId = item.id;
              this.$emit('onhold:activated', item.id);
              this.$emit('update:modelValue', item.id);
            }
          });
        } else {
          this.currentActiveId = null;
          this.$emit('onhold:deactivated', item.id);
          this.$emit('update:modelValue', null);
        }
      }
    },
    handleAcceptModal() {
      this.currentActiveId = this.confirmingItemID;
      this.$emit('onhold:activated', this.confirmingItemID);
      this.$emit('update:modelValue', this.confirmingItemID);
    },
  },
};
</script>
